import { render, staticRenderFns } from "./dependentInclusionSave.vue?vue&type=template&id=7bb1641a&scoped=true&"
import script from "./dependentInclusionSave.vue?vue&type=script&lang=js&"
export * from "./dependentInclusionSave.vue?vue&type=script&lang=js&"
import style0 from "./dependentInclusionSave.vue?vue&type=style&index=0&id=7bb1641a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb1641a",
  null
  
)

export default component.exports